import React, { FC, memo } from 'react';
import { default as MuiChip } from '@material-ui/core/Chip';
import CustomChip from './CustomChip';
import { ChipType, MuiChipColor } from './types';

// 這邊主要製作第三種 variant => surveycake

const Chip: FC<ChipType> = ({
  variant,
  active,
  color,
  label,
  ...restProps
}) => {
  if (!label) {
    return null;
  }
  if (variant === 'surveycake') {
    return (
      <CustomChip color={color} active={active} label={label} {...restProps} />
    );
  }

  return (
    // color 如果傳入不符合，Material 會 warning
    <MuiChip
      color={color as MuiChipColor}
      variant={variant}
      label={label}
      {...restProps}
    />
  );
};

export default memo(Chip);
